import { schema } from "normalizr";
import { UserSchema } from "./user";

export const UsersSchema = new schema.Array(UserSchema);
